import { render, staticRenderFns } from "./ModuleCard.vue?vue&type=template&id=a22743c2&"
import script from "./ModuleCard.vue?vue&type=script&lang=js&"
export * from "./ModuleCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports